import React, { useEffect, Suspense } from "react";
import "./App.css";
import { setupIonicReact } from "@ionic/react";
/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
/* import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css"; */
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { Capacitor } from "@capacitor/core";
import { Smartlook } from "@awesome-cordova-plugins/smartlook";

import {
  AppTrackingTransparency,
  AppTrackingStatusResponse,
} from "capacitor-plugin-app-tracking-transparency";
import "capacitor-plugin-app-tracking-transparency"; // only if you want web support
import {
  FirestoreProvider,
  FunctionsProvider,
  useFirebaseApp,
  AuthProvider,
  StorageProvider,
} from "reactfire";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
} from "firebase/auth";
import { ModalContextProvider } from "./context/modalContext";

import { GameProvider } from "context/gameContext";
import { Helmet } from "react-helmet";
import LoadingComponent from "components/loading";
import ErrorBoundary from "./components/errorBoundary";
import MaintananceComponent from "components/maintanance";
import InitializeGameData from "utils/initializeGameData";
import InitializeUrlListener from "./utils/initializeUrlListener";
import AppRoutes from "views";
import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { register } from "swiper/element/bundle";
import "swiper/css";
//import "swiper/css/navigation";
import Notifications from "views/header/notifications";
import AdMobComponent from "utils/adMob";

setupIonicReact();
const App = () => {
  useEffect(() => {
    async function getStatus() {
      const response = await AppTrackingTransparency.getStatus();
      return response;
    }
    async function requestPermission() {
      const response = await AppTrackingTransparency.requestPermission();

      if (response.status == "authorized") {
        FirebaseAnalytics.setCollectionEnabled({
          enabled: true,
        });
      }

      return response;
    }
    //requestPermission();
  }, []);

  // register Swiper custom elements
  register();

  const app = useFirebaseApp();
  const firestoreInstance = getFirestore(app);
  const functionsInstance = getFunctions(app, "europe-west1");
  const firebaseStorage = getStorage(app);

  let auth;
  if (Capacitor.isNativePlatform()) {
    if (Capacitor.getPlatform() === "ios") {
      Purchases.configure({
        apiKey: process.env.REACT_APP_REVENUECAT_IOS_API_KEY,
      });
    } else if (Capacitor.getPlatform() === "android") {
      Purchases.configure({
        apiKey: process.env.REACT_APP_REVENUECAT_ANDROID_API_KEY,
      });
    }

    auth = initializeAuth(app, {
      persistence: indexedDBLocalPersistence,
    });

    Smartlook.setProjectKey({
      key: process.env.REACT_APP_SMARTLOOK_KEY,
    });
    Smartlook.start();
  } else {
    auth = getAuth(app);
  }

  return (
    <FirestoreProvider sdk={firestoreInstance}>
      <StorageProvider sdk={firebaseStorage}>
        <FunctionsProvider sdk={functionsInstance}>
          <AuthProvider sdk={auth}>
            <Suspense fallback={<LoadingComponent text={"Loading"} />}>
              <GameProvider>
                <ErrorBoundary>
                  <IonApp>
                    <ModalContextProvider>
                      <InitializeUrlListener />
                      {Capacitor.isNativePlatform() && <AdMobComponent />}
                      <InitializeGameData />
                      <Helmet>
                        <meta charSet="utf-8" />
                        <title>Prediction</title>
                        <meta
                          name="viewport"
                          content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
                        />
                      </Helmet>

                      <AppRoutes />
                    </ModalContextProvider>
                  </IonApp>
                </ErrorBoundary>
              </GameProvider>
            </Suspense>
          </AuthProvider>
        </FunctionsProvider>
      </StorageProvider>
    </FirestoreProvider>
  );
};
export default App;
